
import axios from 'axios'
import React, { useState, useEffect, Fragment } from 'react'
import { useCookies } from 'react-cookie'
import { useNavigate } from 'react-router-dom'
import LogoutButton from '../Components/LogoutButton'
import { useStateValue } from '../Utils/StateProvider'

import { AiFillHome } from 'react-icons/ai'
import { RiAppsFill, RiMenu4Line } from 'react-icons/ri'
import { BiSupport, BiTimeFive, BiTransferAlt } from 'react-icons/bi'
import { BsArrowLeft, BsFillCreditCardFill, BsFillMoonStarsFill } from 'react-icons/bs'
import { FaRegUserCircle } from 'react-icons/fa'
import { IoMdNotificationsOutline } from 'react-icons/io'
import { IoSettingsOutline } from 'react-icons/io5'

import UserDashboard from '../Components/User/UserDashboard'
import Payments from '../Components/User/Payments'
import Cards from '../Components/User/Cards'
import Services from '../Components/User/Services'

import '../Styles/Dashboard.css'
import { CgSun } from 'react-icons/cg'
import Aside from '../Components/User/Aside'
import Settings from '../Components/User/Settings'


function Dashboard() {
    const [{ windowDimensions, activeTheme, url, customer, activities, activeMenu, showAside, settings }, payload] = useStateValue()
    const [cookies, removeCookie] = useCookies(['bearerToken', 'alive', 'uid'])
    const [content, setContent] = useState('')
    const [device, setDevice] = useState('desktop')
    const [currentTime, setCurrentTime] = useState('00:00')
    const [menuState, setMenuState] = useState('menu-container')
    const [unread, setUnread] = useState(0)

    const navigate = useNavigate()

    const setTheme = theme => {
        payload({type: 'SET_THEME', theme})
    }

    const getCustomer = async source => {
        try {
            const options = {
                headers: {
                    Authorization: `Bearer ${cookies.bearerToken}`
                }
            }
            const __data = await axios.get(`${url}/api/u/activities`, options)

            payload({
                type: 'SET_ACTIVITIES',
                activities: __data.data.activities
            })
            
        } catch(err) {
            removeCookie('bearerToken')
            removeCookie('uid')
            removeCookie('alive')
        }
    }

    const configTimer = () => {
        let now = new Date()
        now = now.toLocaleTimeString()

        setCurrentTime(now.split(':').slice(0, 2).join(':'))
    }

    useEffect(() => {
        const source = axios.CancelToken.source()
        payload({
            type: 'TOGGLE_HEADER',
            state: false
        })
        if (cookies.bearerToken) getCustomer(source)

        const interval = setInterval(() => configTimer(), 1000)

        return () => {
            source.cancel()
            clearInterval(interval)
        }
    }, [])

    useEffect(() => {
        if (windowDimensions.width <= 960) {
            setDevice('mobile')
            setMenuState('menu-container hide')
        }
    }, [windowDimensions])

    useEffect(() => {
        if (device === 'mobile') setMenuState('menu-container hide')
        const order = activeMenu.split(',')
        switch(order[0].trim()) {
            case 'payments':
                if (order.length <= 1)
                    setContent(<Payments />)
                else
                    if (order.length === 2)  setContent(<Payments screen={order[1]} />)
                    else setContent(<Payments screen={order[1]} beneficiary={JSON.parse(order.slice(2, order.length).join(', '))} />)
                break;
            case 'cards':
                setContent(<Cards />)
                break;
            case 'services':
                setContent(<Services />)
                break;

            default:
                setContent(<UserDashboard bearerToken={cookies.bearerToken} />)

        }
    }, [activeMenu])

    useEffect(() => {
        let _unread = activities.filter(activity => parseInt(activity.viewed) < 1)
        setUnread(_unread.length)
    }, [activities])
    
    return (
        !cookies.bearerToken || 
        [undefined, 'undefined', null, 'null'].includes(cookies.bearerToken) ||
        !cookies.alive ||
        parseInt(cookies.alive) !== 1 ? (
            navigate('/')
        ) : (
            <main className={`dashboard ${activeTheme}`}>
                <div className="main-container">
                    <div className={menuState}>
                        <div className="menu-icon-container">
                            <BsArrowLeft onClick={() => setMenuState('menu-container hide')} />
                        </div>
                        <div className="profile">
                            <h3>
                                Good
                                {
                                parseInt(currentTime.split(':')[0]) < 12 && (
                                    <span> Morning </span>
                                )
                                }
                                {
                                parseInt(currentTime.split(':')[0]) > 12 && parseInt(currentTime.split(':')[0]) < 16 && (
                                    <span> Afternoon </span>
                                )
                                }
                                {
                                parseInt(currentTime.split(':')[0]) >= 16 && (
                                    <span> Evening </span>
                                )
                                } 
                                {customer?.fname}
                            </h3>
                            <strong>{currentTime}<BiTimeFive /></strong>
                        </div>
                        <ul>
                            <li className={activeMenu.split(',').includes('dashboard') ? 'active' : ''} onClick={() => payload({ type: 'SET_ACTIVE_MENU', order: 'dashboard'})}>
                                <h1>Dashboard</h1>
                                <AiFillHome />
                            </li>
                            <li className={activeMenu.split(',').includes('payments') ? 'active' : ''} onClick={() => payload({ type: 'SET_ACTIVE_MENU', order: 'payments'})}>
                                <h1>Payments</h1>
                                <BiTransferAlt />
                            </li>
                            <li className={activeMenu.split(',').includes('cards') ? 'active' : ''} onClick={() => payload({ type: 'SET_ACTIVE_MENU', order: 'cards'})}>
                                <h1>Cards</h1>
                                < BsFillCreditCardFill />
                            </li>
                            <li className={activeMenu.split(',').includes('services') ? 'active' : ''} onClick={() => payload({ type: 'SET_ACTIVE_MENU', order: 'services'})}>
                                <h1>Services</h1>
                                <RiAppsFill />
                            </li>
                        </ul>

                        <div className="menu-footer">
                            <LogoutButton />
                        </div>
                    </div>
                    <div className="content-container">
                        <div className="utilities-bar">
                            <div className="menu-icon-container">
                                <RiMenu4Line onClick={() => setMenuState('menu-container')} />
                            </div>
                            <ul>
                                <li>
                                    <BiSupport />
                                </li>
                                <li onClick={() => payload({ type: 'TOGGLE_ASIDE', aside: showAside})}>
                                    {
                                        unread > 0 && (
                                            <div className="notification-counter">
                                                {unread}
                                            </div>
                                        )
                                    }
                                    <IoMdNotificationsOutline />
                                </li>
                                <li>
                                    <IoSettingsOutline onClick={() => payload({ type: 'TOGGLE_SETTINGS', display: 'account'})} />
                                </li>
                                <li>
                                    <div className="theme-toggle">
                                        { activeTheme === 'light' ? 
                                            <BsFillMoonStarsFill className="left" onClick={() => setTheme('dark')} /> : 
                                            <CgSun className="right" onClick={() => setTheme('light')} />
                                        }
                                    </div>
                                </li>
                            </ul>
                        </div>
                        {content}
                    </div>
                </div>
                {
                    showAside && (
                        <Aside />
                    )
                }
                {
                    settings && (
                        <Settings display={settings} />
                    )
                }
            </main>
        )
    )
}

export default Dashboard
